// Đổi đơn vị đang làm việc — tài khoản thuộc nhiều đơn vị (vừa là chủ shop riêng vừa là nhân viên nơi khác, hoặc nhân
// viên của nhiều đơn vị — docs/KE_HOACH_THANH_VIEN_DON_VI.md). Một đơn vị thì không hiện gì.
import { useState } from 'react'
import { ArrowLeftRight, Check, ChevronDown } from 'lucide-react'
import type { Shop } from '@/lib/auth'
import { cn } from '@/lib/utils'

const TYPE_LABEL: Record<string, string> = { agency: 'Đại lý', ctv: 'CTV', shop: 'Shop' }

export function roleLine(u: Shop): string {
  const type = TYPE_LABEL[u.tenantType ?? 'shop'] ?? 'Đơn vị'
  if (u.role === 'staff') return `${type} · Nhân viên${u.staff?.roleName ? ` · ${u.staff.roleName}` : ''}`
  return `${type} · Chủ`
}

export function UnitSwitcher({ units, activeId, onSwitch, dense = false }: {
  units: Shop[]
  activeId: string | null
  onSwitch: (shopId: string) => void | Promise<void>
  dense?: boolean
}) {
  const [open, setOpen] = useState(false)
  const [busy, setBusy] = useState<string | null>(null)
  if (units.length <= 1) return null
  return (
    <div className="rounded-lg border border-rule">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className={cn('motion-state flex w-full items-center gap-2.5 px-2 text-left text-sm font-medium text-accent hover:bg-accent/5', dense ? 'min-h-[48px] py-2' : 'min-h-11 py-1.5')}
      >
        <span className="grid size-7 shrink-0 place-items-center rounded-lg bg-accent/10" aria-hidden>
          <ArrowLeftRight className="size-4" />
        </span>
        <span className="flex-1">Đổi đơn vị ({units.length})</span>
        <ChevronDown className={cn('size-4 shrink-0 transition-transform', open && 'rotate-180')} aria-hidden />
      </button>
      {open && (
        <ul className="border-t border-rule">
          {units.map((u) => {
            const active = u.shopId === activeId
            return (
              <li key={u.shopId}>
                <button
                  type="button"
                  disabled={active || busy !== null}
                  onClick={async () => {
                    setBusy(u.shopId)
                    try {
                      await onSwitch(u.shopId)
                    } finally {
                      setBusy(null)
                      setOpen(false)
                    }
                  }}
                  className="motion-state flex min-h-11 w-full items-center gap-2 px-3 py-2 text-left hover:bg-paperSoft disabled:cursor-default"
                >
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-sm text-ink" title={u.name}>{u.name}</span>
                    <span className="block truncate text-xs text-muted">{roleLine(u)}</span>
                  </span>
                  {active ? <Check className="size-4 shrink-0 text-ok" aria-label="Đang mở" /> : busy === u.shopId ? <span className="text-xs text-muted">Đang chuyển…</span> : null}
                </button>
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}
